export default "__VITE_ASSET__BtFiMY$N__"